/* eslint-disable @typescript-eslint/no-useless-constructor */
import React, { Component } from 'react';
import { WithStyles } from 'decorators/withStyles';
import Grid from '@material-ui/core/Grid';
import { SvgIcon } from '../SvgIcon';
import Tooltip from '../Tooltip';

interface IProps {
  text: string;
  width: string | number;
  height: string | number;
  classes?: any;
  onClick?: Function;
}

interface IState {
  textInput: any;
  open: boolean;
  textTooltip: string;
}
@WithStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'column nowrap',
    marginBottom: 24
  },
  header: {
    background: '#ECEFF1',
    borderRadius: '4px 4px 0px 0px',
    padding: 8
  },
  copySpan: {
    color: theme.variables.colors['primaryColor'],
    marginLeft: 5
  },
  copyContainer: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '& svg path': {
      fill: theme.variables.colors['primaryColor']
    }
  },
  textArea: {
    width: '100%',
    borderRadius: '0px 0px 4px 4px',
    resize: 'none',
    fontWeight: 600,
    fontFamily: 'Open Sans',
    padding: '16px 0',
    background: '#F9FAFB',
    fontStyle: 'normal',
    color: '#37474F',
    height: 'inherit',
    border: 'none',
    overflow: 'auto',
    fontSize: 14,
    '&:focus': {
      outlineStyle: 'none',
      outlineOffset: 0,
      border: 'none'
    }
  }
}))
export default class TextAreaCopyToClipboard extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { open: false, textTooltip: '', textInput: '' };
  }

  setTextInputValue = (input: any) => {
    this.setState({ textInput: input });
  };

  focusTextInput = (event: any) => {
    event.preventDefault();
    this.state.textInput.focus();
    this.state.textInput.select();
    document.execCommand('Copy');
    this.setState({ open: true, textTooltip: 'Copiado!' });
    setTimeout(() => this.setState({ open: false, textTooltip: '' }), 1500);
  };

  render(): JSX.Element {
    const { text, classes, width, height, onClick } = this.props;
    const { open, textTooltip } = this.state;

    return (
      <div className={classes.container} style={{ width, height }}>
        <Grid
          onClick={event => {
            if (!!onClick) {
              onClick(event);
            }
            this.focusTextInput(event);
          }}
          container
          justify="flex-end"
          className={classes.header}
        >
          <Tooltip open={open} title={textTooltip}>
            <Grid item className={classes.copyContainer}>
              <SvgIcon name="copy" />
              <span className={classes.copySpan}>Copiar</span>
            </Grid>
          </Tooltip>
        </Grid>
        <textarea ref={this.setTextInputValue} className={classes.textArea} value={text} />
      </div>
    );
  }
}
